<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SalesDetailPropertyBasics from './SalesDetailPropertyBasics.vue';
import SalesDetailPropertyLegal from './SalesDetailPropertyLegal.vue';
import SalesDetailPropertyTerms from './SalesDetailPropertyTerms.vue';

const props = defineProps({
  summary: { type: Boolean, default: false },
  transaction: { type: Object, required: true },
});

const route = useRoute();
const router = useRouter();
const canEdit = computed(
  () =>
    !props.summary && props.transaction.permissions?.can_edit_property_detail
);
const canEditDocuments = computed(
  () =>
    !props.summary && props.transaction.permissions?.can_edit_property_documents
);
const editSection = section =>
  router.push({
    name: 'operacao_imobiliaria_vendas_cadastro_imovel',
    params: {
      accountId: route.params.accountId,
      salesTransactionId: props.transaction.id,
    },
    query: { return_to: 'detail', section },
  });
</script>

<template>
  <div class="grid gap-4">
    <SalesDetailPropertyBasics
      :transaction="transaction"
      :summary="summary"
      :can-edit="canEdit"
      @edit="editSection"
    />
    <SalesDetailPropertyTerms
      :transaction="transaction"
      :summary="summary"
      :can-edit="canEdit"
      @edit="editSection"
    />
    <SalesDetailPropertyLegal
      :transaction="transaction"
      :can-edit="canEdit"
      :can-edit-documents="canEditDocuments"
      @edit="editSection"
    />
  </div>
</template>
